
import { useState } from 'react';
import styles from './index.module.scss'
import { AfsServiceDetailVo } from "@/app/csr-src/apis/afterSales/afterSales.interface";
import TipIcon from "@/app/csr-src/assets/icons/TipIcon.svg";
import cn from "clsx";
import CouponCard from "@/app/csr-src/pages/profile/voucher/components/couponCard/index";
import RefundTipsModal from "@/app/csr-src/pages/order/components/refundTipsModal";

interface detailInfoProps {
  afsDetailInfo: AfsServiceDetailVo;
}
const RefundDetails = ({ afsDetailInfo }: detailInfoProps) => {
  const {
    refundAmountStr,
    couponInfos,
  } = afsDetailInfo || {};
  const amountText =
    "Should receive 5-14 business days afterissued, Your financial institution may take up to 30 days to issue your refund.\nThe specific date depends solely on your financial institution.";
  const couponText =
    "The all-category coupon will be refunded to you only after all items in the order have been fully refunded. The category-specific coupon will not be refunded.";

  const [showRefundTipsModal, setShowRefundTipsModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  return (
    <div className={styles.detail_left_wrap}>
      <div className={styles.refund_item_title}>
        <div className={styles.refund_item_common_title}>
          {/* Estimated refund amount and method */}
          Refund details
        </div>
      </div>
      <div className={styles.refund_item_sub_title}>
        <div>Refund amount</div>
        <div className={styles.price_wrap}>{refundAmountStr}</div>
      </div>
      <div className={styles.refund_item_desc_wrap}>
        <div>Refund returned to original payment method</div>
        <TipIcon
          className={styles.tip_ico}
          onClick={() => {
            setShowRefundTipsModal(true);
            setModalContent(amountText);
          }}
        />
      </div>
      {!!couponInfos?.length && (
        <>
          <div className={cn(styles.refund_item_sub_title, styles.refund_item_divide)}>
            <div>Returned coupon(s)</div>
            <TipIcon
              className={styles.tip_ico}
              onClick={() => {
                setShowRefundTipsModal(true);
                setModalContent(couponText);
              }}
            />
          </div>
          <CouponCard
            data={couponInfos}
            currentTab="available"
            containerStyle={{ width: "100%", marginBottom: "8px" }}
            contentStyle={{ width: "530px" }}
            isShowUseBtn={false}
          />
        </>
      )}

      {/* <div className={styles.coupon_desc}>
      1 coupon(s) for specific items has be returned as it meets the return rules.
    </div> */}
      {showRefundTipsModal && (
        <RefundTipsModal
          isOpen={showRefundTipsModal}
          content={modalContent}
          closeHandler={() => setShowRefundTipsModal(false)}
        />
      )}
    </div>
  )
}

export default RefundDetails;